import { HttpApiService } from "@/shared/services/httpApi.service";

import { REGISTER_API_ENDPOINTS } from "../constants/register.constants";
import type {
  ChangeVerificationEmailRequestDto,
  ChangeVerificationEmailResponseDto,
  RegisterRequestDto,
  RegisterResponseDto,
  ResendVerificationRequestDto,
  ResendVerificationResponseDto,
  VerifyEmailRequestDto,
  VerifyEmailResponseDto,
} from "../types/register.types";
import { turnstileHeaders } from "../utils/turnstile";

export const registerService = {
  register: async (
    body: RegisterRequestDto,
    turnstileToken?: string | null,
  ): Promise<RegisterResponseDto> => {
    const response = await HttpApiService.post<RegisterResponseDto>(REGISTER_API_ENDPOINTS.REGISTER, body, {
      headers: turnstileHeaders(turnstileToken),
    });
    return response.data;
  },

  verifyEmail: async (body: VerifyEmailRequestDto): Promise<VerifyEmailResponseDto> => {
    const response = await HttpApiService.post<VerifyEmailResponseDto>(
      REGISTER_API_ENDPOINTS.VERIFY_EMAIL,
      body,
    );
    return response.data;
  },

  resendVerificationCode: async (
    body: ResendVerificationRequestDto,
  ): Promise<ResendVerificationResponseDto> => {
    const response = await HttpApiService.post<ResendVerificationResponseDto>(
      REGISTER_API_ENDPOINTS.RESEND_VERIFICATION,
      body,
    );
    return response.data;
  },

  changeVerificationEmail: async (
    body: ChangeVerificationEmailRequestDto,
  ): Promise<ChangeVerificationEmailResponseDto> => {
    const response = await HttpApiService.patch<ChangeVerificationEmailResponseDto>(
      REGISTER_API_ENDPOINTS.CHANGE_VERIFICATION_EMAIL,
      body,
    );
    return response.data;
  },
};
